import { Component, OnInit, Inject, ViewChild, ElementRef, Input, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SnackService } from '../shared-services/snack.service';
import { BackendService } from '../core/backend.service';
import { HistoryProvider } from '../core/browser-providers';
// import { SecurityService } from '../security.service';
import { MediaService } from '../shared-services/media.service';
import { Http, RequestOptionsArgs, Headers, Response } from '@angular/http';
import { NavigationService } from '../shared-services/navigation.service';
import { NgForm } from '@angular/forms';
import { Notificacion } from './notificacion.model';
import { FormControl } from '@angular/forms';
import { MatSelectChange, MatAutocompleteSelectedEvent, MatChipInputEvent } from '@angular/material';
import { Observer } from 'rxjs/Observer';
import { Observable } from 'rxjs/Observable';
import { ENTER } from '@angular/cdk/keycodes';
import { DialogService } from '../shared-components/modals/dialog.service';
import { FormValidatorService } from '../shared-services/form-validator.service';
import { Cliente } from '../cliente/cliente.model';
import { startWith } from 'rxjs/operators/startWith';
import { map } from 'rxjs/operators/map';

@Component({
  selector: 'app-notificacion-add-edit',
  templateUrl: './notificacion-add-edit.component.html',
  styleUrls: ['./notificacion-add-edit.component.scss']
})
export class NotificacionAddEditComponent implements OnInit {

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = false;
  separatorKeysCodes: number[] = [ENTER];

  @ViewChild('form') public notificacionForm: NgForm;
  @ViewChild('clienteInput') clienteInput: ElementRef;
  toppings = new FormControl();

  validationFail = false;
  notificacion: Notificacion;

  messageTitle: string;

  isHD = false;

  clientesChip: string[];
  clientesList: Cliente[] = [];

  myControl: FormControl = new FormControl();

  filteredOptions: Observable<Cliente[]>;

  minDate = new Date();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private snackService: SnackService,
    private backendService: BackendService,
    private formValidatorService: FormValidatorService,
    @Inject(HistoryProvider) private history: History,
    // private securityService: SecurityService,
    private http: Http,
    private mediaService: MediaService,
    private navigationService: NavigationService,
    private dialogService: DialogService,
    private renderer: Renderer2,
  ) { }

  ngOnInit() {

    this.backendService.getClientes('/clientes/all').then(
      res => {
        this.clientesList = res as Cliente[];

        this.filteredOptions = this.myControl.valueChanges
        .pipe(
          startWith(''),
          map(val => this.filterUsers(val))
        );

      }
    );

    this.route.data.subscribe(data => {
      this.notificacion = data.notificacion;
      this.clientesChip = this.notificacion.clientesChip ? this.notificacion.clientesChip : [];
    });

    this.messageTitle = this.notificacion.id ? 'Edición de notificación' : 'Alta de notificación';

    this.filter();
    this.mediaService.isHighDefinition.subscribe(isHD => this.isHD = isHD);
  }

  back() {
    this.navigationService.back();
  }

  async save() {
    if (this.validateForm()) {
      this.invokeSave();
    }
  }

  validateForm() {
    let validationsOK = false;

    // Valida el resto de las contnotificaciones con sus validadores
    if (this.formValidatorService.isFormValid(this.notificacionForm)) {
      validationsOK = true;
      this.validationFail = false;
    } else {
      validationsOK = false;
      this.validationFail = true;
    }

    return validationsOK;
  }

  private async invokeSave() {

    if (this.validateForm()) {
      this.saveNotificacion(true);
    }

    return;
  }

  add(event: MatChipInputEvent): void {
    // debugger
    const input = event.input;
    const value = event.value;

    // Reset the input value
    if (input) {
      input.value = '';
    }

    this.myControl.setValue(null);

  }

  async ConfirmSave() {
    this.dialogService.confirm(this.messageTitle,
    '¿Está seguro que desea guardar la notificación?')
    .then( res => {
      if (res) {
        this.saveNotificacion(res);
      }
    });
  }

  async saveNotificacion(res) {
    if (res) {

      this.snackService.spinner(true);

      if (this.notificacion.id) { // Update
        try {
          await this.backendService.update(Notificacion.path, this.notificacion);
          this.snackService.spinner(false);
          this.snackService.success('Notificacion editada');
          this.router.navigate(['/notificaciones']);
        } catch (ex) {
          this.snackService.spinner(false);
          this.snackService.error(ex.message);
        }
      } else {
        try {
          this.notificacion.clientesChip = this.clientesChip;
          await this.backendService.update(Notificacion.path, this.notificacion).then(notificacion =>{
            this.snackService.spinner(false);
            this.snackService.success('Notificacion creada');
            this.router.navigate(['/notificaciones']);
          }).catch(ex => {
            this.snackService.spinner(false);
          });
          
        } catch (ex) {
          this.snackService.spinner(false);
          this.snackService.error(ex.message);
        }
      }
      this.snackService.spinner(false);
    }
  }

  private filter() {
  }

  filterUsers(val: any): Cliente[] {
    if (val == null) {
      return this.clientesList;
    }
    return this.clientesList.filter(option =>
      option.name.toLowerCase().indexOf(val.toLowerCase()) === 0);
  }
}



// WEBPACK FOOTER //
// ./src/app/notificacion/notificacion-add-edit.component.ts